import { useCallback } from 'react';
import type { JSX } from 'react';

import { Loader } from '@change-corgi/design-system/components/progressiveDisclosure';
import { Box } from '@change-corgi/design-system/layout';

import { LazyComponent } from 'src/app/shared/components/layout/lazy';

import type { AskStep } from './Ask';

async function LoadAskStep(): Promise<typeof AskStep> {
	return (await import(/* webpackChunkName: "pages/start-a-petition-steps-ask" */ './Ask')).AskStep;
}

export function AskLoader(): JSX.Element {
	const loadComponent = useCallback(LoadAskStep, []);

	return (
		<LazyComponent
			loadComponent={loadComponent}
			fallback={
				<Box margin="auto">
					<Loader />
				</Box>
			}
		/>
	);
}

export const preloadAskStep = LoadAskStep;
